import { type Common } from './common.js';

interface SingleContentRequest {
  embedId: string;
  timeZone?: string;
  mode?: 'SINGLE_CONTENT';
  filterParams?: string;
}

interface ApplicationRequest {
  organizationId: string;
  timeZone?: string;
  mode: 'APPLICATION';
}

export type GetOmniReportUrlArgs = SingleContentRequest | ApplicationRequest;

export class API {
  common: Common;
  baseEndpoint = '/business-intelligence-embed';

  constructor(common: Common) {
    this.common = common;
  }

  async getOmniReportUrl(args: GetOmniReportUrlArgs): Promise<{ src: string }> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, args);
  }
}
